import View from './view'
import EmailMarketingCard from './EmailMarketingCard'

export default EmailMarketingCard(View)
